<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex xs12 md6>
        <material-card color="green" title="Lecture Sheet Params">
          
          <v-form ref="chapterFrom" v-model="valid" lazy-validation>
            <v-select
              :items="courseList"
              label="Select Course"
              item-text="name"
              item-value="id"
              v-model="question.course_id"
              class="mt-4"
              @change="onSelectCourse(question.course_id)"
              :rules="courseIDRules"
            ></v-select>
            <v-select
              clearable
              :items="courseSubjectList"
              label="Select Subject"
              item-text="name"
              item-value="subject_id"
              v-model="question.subject_id"
              class="mt-4"
              :rules="subject_IDRules"
              @change="onSelectSubject(question.course_id, question.subject_id)"
            ></v-select>
            <v-layout wrap>
            <v-flex sm10>
              <v-select
                clearable
                :items="chapterList"
                label="Select Chapter"
                item-text="name"
                item-value="id"
                v-model="question.chapter_id"
                class="mt-4 col6"
                :rules="chapter_IDRules"
                @change="onSelectChapter(question.chapter_id)"
              ></v-select>
            </v-flex>
            <v-flex sm2 text-xs-right>
              
        <v-dialog :disabled="!question.subject_id" v-model="dialogChapter" width="1000" hegiht="auto" persistent>
          <template v-slot:activator="{ on }">
            
                <v-flex
                  xs12
                  md4
                >
            <v-btn
             :disabled="!question.subject_id"
              color="success"
              dark
              v-on="on"
            >
              Create
            </v-btn>
            
                </v-flex>
          </template>

          <v-card>
        
            <Form
              :Item="chapterItem"
              :Field="chapterInputFields"
              :Value="valueObj"
              @emitted="saveChapter"
              @closed="closeModal"
              />

          </v-card>
        </v-dialog>
        </v-flex>
        
        </v-layout>
      <v-layout wrap>
        <v-flex sm10>
            <v-select
            clearable
              :items="lecture_videoList"
              label="Select Lecture Video"
              item-text="title"
              item-value="id"
              v-model="question.lecture_id"
              class="mt-4"
              :rules="lecture_IDRules"
              @change="onSelectLecture(question.lecture_id)"
            ></v-select>
            
        </v-flex>
        
            <v-flex sm2 text-xs-right>
              
        <v-dialog :disabled="!question.chapter_id" v-model="lectureDialog" width="1000" hegiht="auto" >
          <template v-slot:activator="{ on }">
            
                <v-flex
                  xs12
                  md4
                >
            <v-btn :disabled="!question.chapter_id"
              color="success"
              dark
              v-on="on"
            >
              Create
            </v-btn>
            
                </v-flex>
          </template>

          <v-card>
        
             <FormLecture
              :ProgressBar="uploadPercentage"
              :DisableButton="disableButton"
              :Item="lectureItem"
              :Value="lectureValueObj"
              @emitted="submitLectureVideo"
              />

          </v-card>
        </v-dialog>
        </v-flex>
        </v-layout>
          </v-form>
        </material-card>
      </v-flex>
      <v-flex xs12 md6>
        <material-card
          v-if="question.course_id != null"
          color="green"
          :title="quiz_title"
          text=""
        >
          
              
            <v-layout wrap v-if="question.chapter_id">
                <v-flex xs9 md9>
              <v-card v-if="sheetList.length">
                <v-content style="padding-left: 10px">
                <v-list px-0>
                    <v-layout wrap  v-for="(sheet,index) in sheetList" :key="index">
                      <v-flex xs9 md9>
                        <a  :href="'http://api.bacbonschool.com/uploads/Lectures/'+sheet.url" target="_blank">
                         {{ index+1 }}.  {{ sheet.title }}
                          
                        </a>
                      </v-flex>
                      <v-flex xs3 md3 class="text-right">
                        <a href="#" @click.prevent="openDeleteDialog(sheet)">
                         <v-icon class="red--text darken-2">mdi-delete</v-icon>
                        </a>
                      </v-flex>
                    </v-layout>

                </v-list>
                </v-content>
              </v-card>
              <v-card v-else>
                <v-content style="padding-left: 10px">
                  <b>No lecture has been added</b>
                </v-content>
              </v-card>
                </v-flex>
                <v-flex xs3 md3 style="padding: 0">
                    
                    <v-dialog v-model="scriptDialog" width="1000" hegiht="auto">
                    <template v-slot:activator="{ on }">
                        <v-flex xs12 md12 style="padding: 0">
                            <v-btn color="success" dark v-on="on">Add</v-btn>
                        </v-flex>
                    </template>
                    <v-card>
                        <FormScript
                        :Item="scriptItem"
                        :Value="valueObj"
                        @emitted="saveLectureSheet"
                        />
                    </v-card>
                    </v-dialog>
                </v-flex>
            </v-layout>
        </material-card>
        
        <v-dialog v-model="dialogDeleteScript" width="1000" hegiht="auto" persistent>
          <template v-slot:activator="{ on }">
            
      
          </template>

          <v-card>
            
          <v-container>
            <material-card
              :title="'Delete'"
              color="red"> 
              
            <v-flex
              xs12>
              You are going to delete {{  deleteItem.title }}
              <h3>
                
                Are you sure!!
              </h3>
            </v-flex>
            </material-card>
            <v-flex
              xs12
              text-xs-right>
              <v-btn @click="deleteScript"
                class="mx-0 font-weight-light"
                color="success" >Yes</v-btn>
              <v-btn @click="closeDeleteDialog"
                class="mx-2 font-weight-light"
                color="info">No</v-btn>
                
            </v-flex> 
          </v-container>
          </v-card>
        </v-dialog>
        <v-snackbar
          :color="color"
          :bottom="bottom"
          :top="top"
          :left="left"
          :right="right"
          v-model="snackbar"
          dark
        >
          <v-icon color="white" class="mr-3">mdi-bell-plus</v-icon>
          <div>{{ noticeMessage }}</div>
          <v-icon size="16" @click="snackbar = false">mdi-close-circle</v-icon>
        </v-snackbar>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex"
import Form from "@/views/Form"
import ExamList from "@/views/ExamList"
import FormLecture from '@/views/FormLecture'
import FormScript from '@/views/FormScript'
export default {
  metaInfo() {
    return {
      title: "Lecture Sheet | Admin"
    };
  },
  components: {
    Form,
    FormLecture,
    FormScript,
    ExamList
  },
  computed: {
    ...mapState('course_subjects', [
      'courseList',
      'courseDetail',
      'subjectDetail',
      'courseSubjectList',
      'subjectListNotInCourse',
      'chapterList',
      'examList',
      'lecture_videoList',
      'examDetail',
      'sheetList',
      'question',
      'quiz_title',
      'uploadPercentage'

    ])
  },
  mounted() {
    this.getcourselist()
    this.getCourseSubjectList(this.$route.params.id)
    this.getCourseDetails(this.$route.params.id)
  },
  data() {
    return {
      disableButton: false,
      deleteItemIndex: Number,
      panel: [false],
      valid: true,
      color: null,
      chapter: {},
      deleteItem: {},
      colors: ['warning'],
      top: true,
      bottom: false,
      left: false,
      right: false,
      snackbar: false,
      headers: [
        {
          sortable: true,
          text: 'Chapter',
          value: 'name'
        }
      ],
      dialog: false,
      dialogChapter: false,
      dialogDeleteScript: false,
      lectureDialog: false,
      scriptDialog: false,
      noticeMessage: '',
      valueObj: {},
      chapterNameRules: [
        v => !!v || 'Chapter is required'
        // v => (v && v.length <= 30) || 'First name must be less than 30 characters'
      ],
      subject_IDRules: [v => !!v || 'Please select subject'],
      chapter_IDRules: [],
      quiz_IDRules: [v => !!v || 'Please select quiz'],
      courseIDRules: [v => !!v || 'Please select subject'],
      lecture_IDRules: [],
      item: {
        title: 'Add new Question',
        subTitle: 'This is the subtitle',
        width: 'md6',
        submitText: 'Submit'
      },
      scriptItem: {
        'title': 'Upload Lecture Sheet',
        'width': 'md6',
        'submitText' : 'Submit'
      },
      chapterItem: {
        'title': 'Create New Chapter',
        'width': 'md6',
        'submitText' : 'Submit'
      },
      chapterInputFields: [
        {
          label: 'Chapter Name',
          type: 'text',
          isEnable: true,
          name: 'name',
          formName: 'Chapter name',
          nameRules: [
            v => !!v || 'Chapter name is required',
            v => (v && v.length <= 190) || 'Chapter name must be less than 190 characters'
          ]
        },
        {
          label: 'Chapter Name (Bangla)',
          type: 'text',
          isEnable: true,
          name: 'name_bn',
          formName: 'Chapter name (Bangla)',
          nameRules: [
            v => !!v || 'Chapter name (Bangla) is required',
            v => (v && v.length <= 190) || 'Chapter name must be less than 190 characters'
          ]
        },
        {
          label: 'Price',
          type: 'number',
          isEnable: true,
          name: 'price',
          formName: 'price',
          nameRules: [
            v => !!v || 'Price is required'
          ]
        }
      ],
      lectureItem: {
        title: 'Add new Lecture Video',
        subTitle: 'This is the subtitle',
        width: 'md6',
        submitText: 'Submit'
      },
      lectureValueObj: {}
    }
  },
  created () {
    this.$store.state.course_subjects.question = {}
  },
  methods: {
    ...mapActions('course_subjects', [
      'fetchData',
      'CreateCourse',
      'getcourselist',
      'getCourseSubjectList',
      'getSubjectListNotInCourse',
      'addSubjectToCourse',
      'getCourseDetails',
      'getChapterNameListBySubjectId',
      'storeChapter',
      'getExamDetailById',
      'getLectureDetails',
      'storeLectureVideo',
      'getExamListByChapter',
      'storeChapterScript',
      'deleteChapterScript',
      'storeLectureScript',
      'deleteLectureScript',
    ]),
    getBackData (value) {
    },
    onSelectChapter (chapter_id) {
      this.question.lecture_id = null
      this.getExamListByChapter(chapter_id)
    },
    onSelectLecture (lecture_id) {
      this.getLectureDetails(lecture_id)
    },
    onSelectQuiz (quiz_id) {
      let obj = {
        course_id: this.question.course_id,
        subject_id: this.question.subject_id,
        chapter_id: this.question.chapter_id,
        lecture_id: this.question.lecture_id,
        quiz_id: quiz_id
      }
      this.getExamDetailById(obj)
    },
    onSelectCourse (course_id) {
      this.question.subject_id = null
      this.$refs.chapterFrom.resetValidation()
      this.getCourseSubjectList(course_id)
    },
    onSelectSubject (course_id, subject_id) {
      this.question.chapter_id = null
      this.question.lecture_id = null
      this.$refs.chapterFrom.resetValidation()
      let obj = {
        courseId: course_id,
        subjectId: subject_id
      }
      this.getChapterNameListBySubjectId(obj)
    },

    saveChapter (obj) {
      obj.course_id = this.question.course_id
      obj.subject_id = this.question.subject_id
      
      if (this.$refs.chapterFrom.validate()) {
        this.storeChapter(obj).then(response => {
          if (response.status === 'OK') {
            this.dialogChapter = false
            this.chapter.name = null
            this.$refs.chapterFrom.resetValidation()
            this.$store.state.course_subjects.chapterList.push(response.result)
            this.color = 'success'
            this.subject_id = null
            this.noticeMessage = 'Success! ' + response.messages
            this.snack('top')
          } else {
            this.color = 'warning'
            this.noticeMessage = 'Warning! ' + response.messages
            this.snack('top')
          }
        })
      } else {
      }
    },
    snack (...args) {
      this.top = false
      this.bottom = false
      this.left = false
      this.right = false
      for (const loc of args) {
        this[loc] = true
      }
      this.snackbar = true
    },
    submitLectureVideo (data) {
      this.disableButton = true
  
      this.storeLectureVideo(data).then((response) => {
        if (response.status == 'OK') {
          this.lectureDialog = false
          this.disableButton = false
          this.$store.state.course_subjects.lecture_videoList.push(response.result)
          this.color= 'success'
          this.noticeMessage = response.messages
          this.snack('top')
        } else {
          this.color= 'warning'
          this.noticeMessage = response.messages
          this.snack('top')
          this.lectureDialog = false
          this.disableButton = false
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    saveLectureSheet (data) {
      if (this.question.lecture_id) {
        this.storeLectureScript(data).then((response) => {
          if (response.status === 'OK') {
            this.scriptDialog = false
            this.sheetList.push(response.result)
            this.color = 'success'
            this.noticeMessage = response.messages
            this.snack('top')
          } else {
            this.noticeMessage = response.messages
            this.snack('top')
          }
        }).catch((err) => {
          console.log(err)
        })
      } else {
        this.storeChapterScript(data).then((response) => {
          if (response.status === 'OK') {
            this.scriptDialog = false
            this.sheetList.push(response.result)
            this.color = 'success'
            this.noticeMessage = response.messages
            this.snack('top')
          } else {
            this.color = 'warning'
            this.noticeMessage = response.messages
            this.snack('top')
          }
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    closeModal () {
      this.dialogChapter = false
    },
    closeDeleteDialog () {
      this.dialogDeleteScript = false
    },
    openDeleteDialog (item, index) {
      this.deleteItem = item
      this.dialogDeleteScript = true
      this.deleteItemIndex = index
    },
    deleteScript () {
      if (this.question.lecture_id == null) {
        this.deleteChapterScript(this.deleteItem.id).then(response => {
          if(response.status == 'OK') {
            this.dialogDeleteScript = false
            this.$store.state.course_subjects.sheetList.splice(this.deleteItemIndex, 1)
            this.color = 'success'
            this.noticeMessage = response.messages
            this.snack('top')
          } else {
            this.color = 'warning'
            this.noticeMessage = response.messages
            this.snack('top')
          }
        })
      } else {
        this.deleteLectureScript(this.deleteItem.id).then(response => {
          if(response.status == 'OK') {
            this.dialogDeleteScript = false
            this.$store.state.course_subjects.sheetList.splice(this.deleteItemIndex, 1)
            this.color = 'success'
            this.noticeMessage = response.messages
            this.snack('top')
            this.dialogDeleteScript = false
          } else {
            this.color = 'warning'
            this.noticeMessage = response.messages
            this.snack('top')
            this.dialogDeleteScript = false
          }
        })
      }
    }
  }
}
</script>
